<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  sync,
  getCarParkList,
} from '@/api/v4ward/carv2/carparksettings';
import { mapGetters } from 'vuex';
var DIC = {
  STATUS: [
    {
      label: '启用',
      value: '1',
    },
    {
      label: '不启用',
      value: '0',
    },
  ],
  LOSE: [
    {
      label: '忽略',
      value: '1',
    },
    {
      label: '不忽略',
      value: '0',
    },
  ],
};
export default {
  data: function () {
    return {
      form: {},
      query: {},
      loading: true,
      reWrite: false,
      firstDisplayFlag: false,
      tempCarParkId: '',
      carParkList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 50,
        tip: false,
        border: true,
        indexLabel: '序号',
        index: true,
        viewBtn: true,
        selection: true,
        columnBtn: false,
        refreshBtn: false,
        searchMenuSpan: 6,
        labelWidth: 120,
        delBtn: false,
        group: [
          {
            label: '车场设置',
            icon: 'el-icon-setting',
            arrow: false,
            dialogDirection: 'rtl',
            column: [
              {
                label: '车场名称',
                prop: 'parkingLotIds',
                hide: true,
                type: 'tree',
                editDisabled: true,
                multiple: true,
                span: 24,
                dicUrl: '/api/v4ward/carv2/ParkSpace/getCarParkList',
                props: { label: 'spaceName', value: 'id' },
                rules: [{ required: true, message: '请选择车场名称', trigger: 'blur' }],
              },
            ],
          },
          {
            label: '车牌模糊匹配设置',
            icon: 'el-icon-setting',
            column: [
              {
                label: '主键',
                prop: 'id',
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: true,
              },
              {
                label: '车场名称',
                prop: 'parkingLotId',
                type: 'tree',
                searchClearable: false,
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                dicUrl: '/api/v4ward/carv2/ParkSpace/getCarParkList',
                props: { label: 'spaceName', value: 'id' },
                rules: [
                  {
                    required: true,
                    message: '请选择车场名称',
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: '启用模糊匹配',
                prop: 'plateMatchOpen',
                type: 'radio',
                dicData: DIC.STATUS,
                display: false,
                tip: '提示：是否开启车牌模糊匹配功能：1是，0否，不配置时默认0',
                tipPlacement: 'top-start',
                rules: [
                  {
                    required: true,
                    message: '请选择是否启用模糊匹配',
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: '忽略首汉字',
                prop: 'ignoreFirstLetter',
                type: 'radio',
                dicData: DIC.LOSE,
                tip: '提示：是否开启车牌忽略首汉字匹配功能：1是，0否，不配置时默认0',
                tipPlacement: 'top-start',
                display: false,
                rules: [
                  {
                    required: true,
                    message: '请选择是否启用模糊匹配',
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: '启用叠加模糊',
                prop: 'matchPlus',
                type: 'radio',
                dicData: DIC.STATUS,
                tip: '提示：是否忽略首汉字与常用字母替换同时模糊匹配',
                tipPlacement: 'top-start',
                display: false,
                rules: [
                  {
                    required: true,
                    message: '请选择是否启用模糊匹配',
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: '参数名称',
                prop: 'paramKey',
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                rules: [
                  {
                    required: true,
                    message: '请输入参数名称',
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: '参数值',
                prop: 'paramValue',
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                rules: [
                  {
                    required: true,
                    message: '请输入参数值',
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: '备注信息',
                prop: 'remark',
                editDisplay: false,
                addDisplay: false,
                span: 24,
                row: 4,
              },
            ],
          },
        ],
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'tree',
            searchClearable: false,
            search: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            dicUrl: '/api/v4ward/carv2/ParkSpace/getCarParkList',
            props: { label: 'spaceName', value: 'id' },
            width: 120,
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '参数名称',
            prop: 'paramKey',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入参数名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '参数值',
            prop: 'paramValue',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入参数值',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            overHidden: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carparksettings_add, false),
        viewBtn: this.vaildData(this.permission.carparksettings_view, false),
        delBtn: this.vaildData(this.permission.carparksettings_delete, false),
        editBtn: this.vaildData(this.permission.carparksettings_edit, false),
        syncBtn: this.vaildData(this.permission.carparksettings_sync, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    //加载列表
    getCarParkList({}).then((res) => {
      this.carParkList = res.data;
      if (this.carParkList.length > 0) {
        this.query.parkingLotId = this.carParkList[0].id;
        this.tempCarParkId = this.carParkList[0].id;
      }
      this.$nextTick(() => {
        this.reWrite = true;
      });
      //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
      this.firstDisplayFlag = true;
    });
  },
  methods: {
    getCarParkNameById(carParkId) {
      let carParkName = '';
      this.carParkList.forEach(function (value, index, array) {
        if (value.id === carParkId) {
          carParkName = value.spaceName;
          return;
        }
      });
      return carParkName;
    },
    rowSave(row, loading, done) {
      row.parkingLotIds = row.parkingLotIds.join(',');
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      row.parkingLotId = row.parkingLotIds.join(',');
      row.parkingLotIds = '';
      if ('PlateMatchOpen' === row.paramKey) {
        row.paramValue = row.plateMatchOpen;
      }
      if ('IgnoreFirstLetter' === row.paramKey) {
        row.paramValue = row.ignoreFirstLetter;
      }
      if ('MatchPlus' === row.paramKey) {
        row.paramValue = row.matchPlus;
      }

      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    syncButton() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据同步?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return sync({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form.parkingLotIds = data.parkingLotId;
          this.form = data;
          if ('PlateMatchOpen' === data.paramKey) {
            this.findObject(this.option.group[1].column, 'plateMatchOpen').display = true;
            setTimeout(() => {
              this.form.plateMatchOpen = data.paramValue;
            });
          } else {
            this.findObject(this.option.group[1].column, 'plateMatchOpen').display = false;
          }
          if ('IgnoreFirstLetter' === data.paramKey) {
            this.findObject(this.option.group[1].column, 'ignoreFirstLetter').display = true;
            setTimeout(() => {
              this.form.ignoreFirstLetter = data.paramValue;
            });
          } else {
            this.findObject(this.option.group[1].column, 'ignoreFirstLetter').display = false;
          }
          if ('MatchPlus' === data.paramKey) {
            this.findObject(this.option.group[1].column, 'matchPlus').display = true;
            setTimeout(() => {
              this.form.matchPlus = data.paramValue;
            });
          } else {
            this.findObject(this.option.group[1].column, 'matchPlus').display = false;
          }
        });
      } else {
        this.findObject(this.option.group[1].column, 'plateMatchOpen').display = true;
        this.findObject(this.option.group[1].column, 'ignoreFirstLetter').display = true;
        this.findObject(this.option.group[1].column, 'matchPlus').display = true;
        setTimeout(() => {
          this.form.plateMatchOpen = '0';
          this.form.ignoreFirstLetter = '0';
          this.form.matchPlus = '0';
        });
      }
      done();
    },
    searchReset() {
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      done();
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (!this.query.parkingLotId) {
        this.query.parkingLotId = this.tempCarParkId;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.getCarParkNameById(this.query.parkingLotId);
            this.tempCarParkId = this.query.parkingLotId;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style></style>
